__webpack_require__.p = "https://tastermpoint-mfe-assistant-stage.maersk.io/mfe/assistant/";